import cx from 'classnames'

type HeartProps = {
  active?: boolean
  liked?: boolean
}

const Heart = ({ active, liked }: HeartProps) => {
  return (
    <svg className="Heart">
      <g>
        <circle
          cx="30"
          cy="24"
          r="14"
          className={cx('Heart__circle', {
            'Heart__circle--active': active,
          })}
        />

        <circle
          cx="30"
          cy="24"
          r="15"
          fill="#fff"
          className={cx('Heart__circle2', {
            'Heart__circle2--active': active,
          })}
        />
      </g>

      <g
        className={cx('Heart__radius', {
          'Heart__radius--active': active,
        })}
      >
        {Array.from(Array(7)).map((_, i) => (
          <circle
            key={i}
            cx="30"
            cy="2"
            transform={`rotate(${51.4 * i} 30 24)`}
          />
        ))}
      </g>

      <g
        className={cx('Heart__radius2', {
          'Heart__radius2--active': active,
        })}
        transform={`rotate(15 30 24)`}
      >
        {Array.from(Array(7)).map((_, i) => (
          <circle
            key={i}
            cx="30"
            cy="5"
            transform={`rotate(${51.4 * i} 30 24)`}
          />
        ))}
      </g>

      <g transform="translate(20 17)">
        <path
          className={cx('Heart__path', {
            'Heart__path--active': active,
            'Heart__path--liked': liked,
          })}
          d="M14.8,0 C12.6942671,0.00417407395 10.7990957,1.19480618 10,3.01557632 C9.19998005,1.19271086 7.30149524,0.00165139134 5.19333333,5.53382193e-16 C2.32666667,0 0,2.6728972 0,5.35825545 C0,11.2274143 8.66666667,16 10,16 C11.3333333,16 20,11.2274143 20,5.35825545 C20,2.6728972 17.6733333,0 14.8,0 Z"
        />
      </g>
    </svg>
  )
}

export default Heart
